export default {"src":"/_next/static/media/dai.7a657408.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};